import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-78287f9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-align-center gap-x-5" }
const _hoisted_2 = { class: "cm-align-center gap-x-5" }

import StrategySetting from './components/strategy-setting.vue'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { PolicySettingType, PolicyType } from '@/views/dashboard/_enum/policy-type'
import { PermissionFe, ServicePermissionService } from '@/services/service-permission.service'
import PolicyManage from '@/views/dashboard/_components/policy-manage/policy-manage.vue'
import { TableOptColumn } from '@/components/cmTable/types'
import { GroupRefreshManage } from '@/services/group'
import { PolicyCommonService, StrategyListDataCommon } from '@/views/dashboard/policy/policy-common.service'
import TaskTimeShow from '@/views/dashboard/_components/task-time/task-time-show.vue'
import { getUnionLabelMap } from './traffic-control-i18n-labels'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, locale } = useI18n()
const unionLabel = getUnionLabelMap()
const injector = useReflectiveInjector([PolicyCommonService])
const groupRefreshManage = injector.get(GroupRefreshManage)
const groupPolicySettingsService = injector.get(PolicyCommonService)
const servicePermissionService = injector.get(ServicePermissionService)
const hasPermission = servicePermissionService.getHasPermission(PermissionFe.flow_monitor)
// 编辑api
const saveOrUpdateApi = groupPolicySettingsService.saveSettings.bind(groupPolicySettingsService)
// 获取当前策略
const getApi = groupPolicySettingsService.getSettings.bind(groupPolicySettingsService)
const visible = ref(false)
const policyManageRef = ref()
const activeRow = ref({} as StrategyListDataCommon)
const fromGroupId = ref()
const customCols = computed<TableOptColumn[]>(() => {
  void locale.value
  return [
    {
      label: t('terminalTrafficStateList.maxUploadSpeed'),
      prop: 'up_speed',
    },
    {
      label: t('terminalTrafficStateList.maxDownloadSpeed'),
      prop: 'down_speed',
    },
    {
      label: t('terminalTrafficStateList.executeTime'),
      prop: 'frequency',
    },
  ]
})
const handleAction = ({ type, ...other }: { type: string;[type: string]: any; }) => {
  console.log(type, other)
  const { validGroupId } = policyManageRef.value
  const types: any = {
    add: () => {
      visible.value = true
      activeRow.value = {} as StrategyListDataCommon
      fromGroupId.value = validGroupId
    },
    edit: async () => {
      visible.value = true
      activeRow.value = other.rowItem
      fromGroupId.value = undefined
    },
  }
  types?.[type]?.()
}
function handleRefresh() {
  groupRefreshManage.refreshGroup()
  policyManageRef.value.tableRef.getList()
}

return (_ctx: any,_cache: any) => {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(PolicyManage, {
      ref_key: "policyManageRef",
      ref: policyManageRef,
      "normal-permission-key": _unref(PermissionFe).flow_monitor,
      triggerTime: "none",
      "strategy-type": _unref(PolicyType).terminal_flow_monitor,
      "custom-cols": customCols.value,
      hiddenLogBtn: () => true,
      "data-type": _unref(PolicySettingType).terminal_flow_monitor,
      onHandleAction: handleAction
    }, {
      table__frequency: _withCtx(({ row }) => [
        _createVNode(TaskTimeShow, {
          frequency: row.strategy.frequency,
          "task-time": row.strategy.regular_tasks
        }, null, 8, ["frequency", "task-time"])
      ]),
      table__up_speed: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/manage/terminal-traffic-control/terminal-traffic-state-list/images/7",
            monochrome: ""
          }),
          _createElementVNode("span", null, _toDisplayString(row.strategy.up_speed) + _toDisplayString(_unref(unionLabel)[row.strategy.up_unit]), 1)
        ])
      ]),
      table__down_speed: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/manage/terminal-traffic-control/terminal-traffic-state-list/images/6",
            monochrome: ""
          }),
          _createElementVNode("span", null, _toDisplayString(row.strategy.down_speed) + _toDisplayString(_unref(unionLabel)[row.strategy.down_unit]), 1)
        ])
      ]),
      _: 1
    }, 8, ["normal-permission-key", "strategy-type", "custom-cols", "data-type"]), [
      [_vShow, !visible.value]
    ]),
    _createVNode(StrategySetting, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      onRefresh: handleRefresh,
      hasPermission: _unref(hasPermission),
      api: { getApi: _unref(getApi), saveOrUpdateApi: _unref(saveOrUpdateApi) },
      id: activeRow.value.id,
      "from-group-id": fromGroupId.value
    }, null, 8, ["modelValue", "hasPermission", "api", "id", "from-group-id"])
  ], 64))
}
}

})